import React from 'react';
import { getIcons } from '_helpers';

export { FleetInfoCard };
 
function FleetInfoCard({ data }) {

    if (!data) {
        return null; 
    }

    const fleet = data?.flotte ?? '',
        depot = data?.depot ?? 'Dépôt non renseigné',
        vehicles = data?.vin?.length ?? '',
        adress1 = data?.adresse?.split('-')[0] ?? 'Adresse non renseignée',
        adress2 = data?.adresse?.split('-')[1] ?? '';

    return (
        <div className={`flex side-panel-card blue`}>
            <div className="flex flex-col gap-4 px-4 pb-2 w-full">
                {/* Première ligne : titre */}
                <div className="flex flex-col gap-4 w-full text-center">
                    <div className="flex-1 text-4xl">Informations</div>                    
                </div>
                {/* Deuxième ligne divisée en 2 sur la largeur */}    
                <div className='flex gap-4 w-full'>                           
                    {/* premier groupe : divisée en 3 sur la largeur */}
                    <div className="flex gap-4 h-24 w-1/2">
                        <div className="flex-1 ">
                            <div className="icon-group details-section">
                                <div className="icon"><img className='h-full mr-1' src={getIcons('corporateFareOutlinedWhite')} alt='bus icon'/></div>
                                <div className="label">Flotte</div>
                                <div className="value">{fleet}</div>
                            </div>
                        </div>
                        <div className="flex-1 ">
                            <div className="icon-group details-section">
                                <div className="icon"><img className='h-full mr-1' src={getIcons('warehouseOutlinedWhite')} alt='bus icon'/></div>
                                <div className="label">Dépot</div>
                                <div className="value">{depot}</div>
                            </div>
                        </div>
                        <div className="flex-1 ">                             
                            <div className="icon-group details-section">
                                <div className="icon pl-2"><img className='h-full' src={getIcons('directionsBusFilledOutlinedWhite')} alt='bus icon'/></div>
                                <div className="label">Véhicules</div>
                                <div className="value">{vehicles}</div>
                            </div>
                        </div>
                    </div>

                    {/* Deuxième groupe : 2 blocs */}
                    <div className="flex w-1/2 pl-4">
                        {/* Premier bloc: icone sur la hauteur */}
                        <div>
                            <img className='h-1/2 mt-[20%]' src={getIcons('placeOutlinedWhite')} alt='bus icon'/>
                        </div>
                        {/* Deuxièeme bloc: 2 lignes sur la hauteur */}
                        <div className="flex flex-col gap-1 mt-2">
                            <div className='flex'>
                                <div className='label'>{adress1}</div>
                            </div>
                            <div className='flex'>
                                <div className='value'>{adress2}</div>
                            </div>                            
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
};
